module.exports = __webpack_public_path__ + "img/transport-belt-connector-frame-main-scanner-nw-ne.e585bbf5.png";